<template>
  <template v-for="(item, index) in items" :key="index">
    <slot name="default" v-bind="{ item, index }" />
  </template>
  <slot v-if="items.length === 0" name="no-results" />
</template>

<script lang="ts">
  import { defineComponent } from "vue"

  export default defineComponent({
    inheritAttrs: false,
    props: {
      items: {
        type: Array,
        default: () => [],
      },
    },
  })
</script>
